// 行内文字超出长度省略处理
export const handleTextOverflowEllipsis = (text: string, limitedNum = 10) => {
  return text.length > limitedNum ? text.substring(0, limitedNum) + '...' : text
}
